import React from 'react';
import { observer } from 'mobx-react';
import { FieldState } from 'formstate';
import { MatField } from 'src/core/components/mat-field';
import { Select, MenuItem, FormControl, InputLabel } from '@material-ui/core';
import * as Styles from './application-information-page.less';
import { AddressForm } from '../../forms/application-information-forms';

interface IAddressProps {
    address: AddressForm;
    disabled: boolean;
    states: string[];
    validate: (fieldState: FieldState<string>) => () => Promise<void>;
}
export const Address: React.FC<IAddressProps> = observer(
    ({ address, validate, disabled = false, states }) => {
        return (
            <>
                <div className={Styles.row}>
                    <div className={Styles.col}>
                        <MatField
                            required
                            fullWidth
                            errorColor
                            disabled={disabled}
                            fieldState={address.$.Street}
                            maxLength={100}
                            label="Home Street Address"
                            onBlur={validate(address.$.Street)}
                        />
                    </div>
                    <div className={Styles.col}>
                        <MatField
                            fullWidth
                            errorColor
                            disabled={disabled}
                            fieldState={address.$.Unit}
                            maxLength={50}
                            label="Unit"
                        />
                    </div>
                </div>
                <div className={Styles.row}>
                    <div className={Styles.col}>
                        <MatField
                            required
                            fullWidth
                            errorColor
                            disabled={disabled}
                            fieldState={address.$.City}
                            maxLength={100}
                            label="City"
                            onBlur={validate(address.$.City)}
                        />
                    </div>
                    <div className={Styles.col}>
                        <div className={Styles.nestedRow}>
                            <div className={Styles.nestedCol}>
                                <FormControl required className={Styles.nestedSelectForm}>
                                    <InputLabel htmlFor="select">State</InputLabel>
                                    <Select
                                        inputProps={{ id: 'addressState' }}
                                        value={address.$.State.value}
                                        disabled={disabled}
                                        onChange={async (e) => {
                                            address.$.State.onChange(e.target.value as string);
                                            await validate(address.$.State)();
                                        }}
                                    >
                                        {states.map((value, index) => (
                                            <MenuItem key={index} value={value}>
                                                {value}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </div>
                            <div className={Styles.nestedCol}>
                                <MatField
                                    required
                                    fullWidth
                                    errorColor
                                    disabled={disabled}
                                    fieldState={address.$.Zip}
                                    maxLength={100}
                                    label="Postal Code"
                                    onBlur={validate(address.$.Zip)}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
);
